import ExerciseStoreAPI from '@/apis/business/teacher/exercise-store-api.js'
import TeacherRankingAPI from '@/apis/business/teacher/teacher-ranking-api.js'

import MISAStoreAPI from '@/apis/business/MISAStore/exercise-store-api.js'
import ExerciseCardAPI from '@/apis/business/teacher/exercise-card-api.js'
import ExerciseFavoriteAPI from '@/apis/business/teacher/exercise-favorite-api.js'
import TeacherGiftCardAPI from '@/apis/business/teacher/teacher-gift-card.js'
import Enumeration from '@/common/enumeration.js'
import { handleMappingAnswer } from '@/views/pages/teacher/storage/create/common/common.js'
import { sessionStorageKeys } from '@/common/storage-keys.ts'
import { sessionStorage } from '@/utils/storage'
export default {
  namespaced: true,

  state: {
    exercisestores: [],
    exercisestoresPopup: [],
    exercise: null,
    teacherRankingOld: null,
    exerciseDefault: null,
    exerciseStore: {
      Status: null,
      GradeID: null,
      SubjectID: '',
      TopicID: null,
      queryText: null
    },
    exerciseLibrary: {
      GradeID: null,
      SubjectID: null,
      TopicID: null,
      queryText: null
    },
    currentItem: {
      GradeID: null,
      SubjectID: null,
      TopicID: null,
      queryText: null
    },
    dataChoosePage: [],
    answerAttachments: [],
    exerciseForShare: [],
    exerc: '',
    counter: {
      ExerciseCompleted: Enumeration.ExerciseStatus.SaveDraft,
      ExerciseDraft: Enumeration.ExerciseStatus.SaveDraft,
      ExerciseLibrary: Enumeration.TypeSource.Library
    },
    ExerciseStoreMISA: Enumeration.TypeSource.MISAStore,
    countLibrary: Enumeration.TypeSource.Library,
    countMISAStore: Enumeration.TypeSource.MISAStore,
    // type: Enumeration.TypeExercise.NewCompose,
    viewActive: Enumeration.ExerciseStoreType.MyPost,
    itemStatus: Enumeration.ExerciseStatus.Complete,
    completeStorage: Enumeration.PreviewAction.CompleteStorage,
    preview: Enumeration.PreviewAction.Preview,
    completeClassroom: Enumeration.PreviewAction.CompleteClassroom,

    // dùng để bật tắt cho phép xem đáp án ở màn hình xem và làm thử
    // bndung
    isShowAnswer: true,
    totalExercise: null,
    totalLibrary: null,
    totalExerciseMISA: null,
    libraryExercises: [],
    shareExercises: [],
    libraryExercisesMISA: [],
    totalExercisePopup: null,
    currentPage: Enumeration.Pagination.CurrentPage,
    subjectShareSchool: [],
    teacherPositive: [],
    exerciseShareSchool: [],
    totalExerciseInformation: {},
    shareSchoolParam: {},
    favoriteExercise: [],
    exercisePublicOverview: [],
    listTeacherGifCard: [],
    exerciseStoresOld: [],
    exerciseShareSchoolOld: [],
    totalFavoriteExercise: null,
    exerciseSharePublicOld: [],
    // Data quản lý page
    dataShares: [
      // {
      //   dataPages: [],
      //   index: ''
      // }
    ],
    exerciseSharePublic: [],
    isShowNoteRanking: false,
    totalExerciseSharePublic: [],
    filterCommunity: {}, // bộ filter tìm kiếm trong tab cộng đồng giáo viên
    resetFilter: false, // check click tab Cộng đòng giáo viên
    exerciseSource: null, // nguồn của học liệu
    sourceCategory: null, // nguồn danh sách mà học liệu được click
    usedCount: 0, // số lượng học liệu sưu tầm của giáo viên
    isShowRecommendShareExercise: false,
    numberShareExerciseToUp: 0
  },

  getters: {
    // exerciseForShare (state) {
    //   const exercisShare = []
    //   state.dataShares.forEach(item => {
    //     const dataChoose = item.dataPages?.filter(data => {
    //       return data.choosed === true
    //     })
    //     exercisShare.push(dataChoose)
    //   })
    //   return exercisShare
    // }

  },

  mutations: {
    /**
     * Hiển thị ranking
     * @param {*} state
     * @param {*} data
     */
    setIsShowNoteRanking (state, data) {
      state.isShowNoteRanking = data
    },
    /**
     * @description Hàm hiển thị tag chia sẻ bài tập
     * @author BNDung
     * @param {*} state
     * @param {*} Id
     */
    setExerciseShared (state, ListId) {
      state.exercisestores = state.exercisestores.map((item) => {
        ListId.map((id) => {
          if (item.Id === id) {
            item.IsShared = true
          }
        })
        return item
      })
    },
    // set giá trị exerciseSource
    setExerciseSource (state, data) {
      state.exerciseSource = data
    },
    // set giá trị sourceCategory
    setSourceCategory (state, data) {
      state.sourceCategory = data
    },
    setExerciseForShareParam (state, data) {
      state.exerciseForShare = data
    },

    /**
     * Xét giá trị cho page
     * @param {*} state
     * @param {*} currentPage
     */
    setCurrentPage (state, currentPage) {
      state.currentPage = currentPage
    },

    // Cập nhật trạng thái bên kho học liệu : IsShare=false
    setExerciseSharedExercise (state, ListId) {
      state.exercisestores = state.exercisestores.map((item) => {
        ListId.map((id) => {
          if (item.Id === id) {
            item.IsShared = false
            state.counter.ExerciseLibrary--
          }
        })
        return item
      })
    },

    // Xóa đi phần từ bên kho học liệu ko load
    setExerciseSharedLibrary (state, ListId) {
      state.libraryExercises = state.libraryExercises.filter(
        (item) => item.Id !== ListId[0]
      )
      state.totalLibrary--
    },

    /**
     * @description Thêm bài tập vào danh sách được chia sẻ
     * @author BNDung
     * @param {*} state
     * @param {*} param
     */
    setNullExerciseForShare (state) {
      state.exerciseForShare = []
    },

    /**
     * @description hàm set lại bài tập chia sẻ
     * @param {*} state
     */
    setInitExerciseStorePopup (state) {
      state.exercisestoresPopup = state.exercisestoresPopup.map((x) => {
        x.isChosen = false
        return x
      })
    },

    /**
     * @description Thêm bài tập vào danh sách được chia sẻ
     * @author BNDung
     * @param {*} state
     * @param {*} param
     */
    addExerciseForShare (state, param) {
      state.exerciseForShare.push(param)
      state.shareExercises.map((item) => {
        if (item.Id === param.Id) {
          item.choosed = true
        }
        return item
      })
    },

    /**
     * Chọn tất cả ExerciseShare
     * @param {*} state
     * @param {*} selectAll
     */
    setAllExercise (state, selectAll) {
      // const exerciseShares = state.shareExercises
      // Trường hợp bỏ chọn tất cả

      if (selectAll) {
        state.shareExercises.map((item) => {
          item.choosed = false
          return item
        })
        // Set lưu giá trị của nút chọn tất cả và bỏ chọn
        state.dataChoosePage.map(item => {
          if (item.index === state.currentPage) {
            item.selectAll = false
          }
        })
        state.exerciseForShare = state.exerciseForShare.filter((itemShare) => {
          return itemShare.choosed !== false
        })
        // Trường hợp duy nhất tại Page 1 khi filter
        if (state.dataShares.length <= 1) { // Số 1 nghĩa là currentpage = 1 duy nhất
          state.exerciseForShare = []
        }
      } else {
        // TH Chọn tất cả
        state.dataChoosePage.push({ selectAll: true, index: state.currentPage })

        // Kiểm tra khi có data được chọn
        if (state.exerciseForShare.length > 0) {
          state.shareExercises.map((item) => {
            const index = state.exerciseForShare.findIndex(itemShare => itemShare.Id === item.Id)
            if (index !== -1) {
              state.exerciseForShare.splice(index, 1)
            }
            item.choosed = true
            state.exerciseForShare.push(item)
          })
        } else {
          // TH Chưa có data được chọn
          state.shareExercises.map((item) => {
            item.choosed = true
            state.exerciseForShare.push(item)
          })
        }
      }
    },

    /**
     * @description Xóa bài tập khỏi danh sách được chia sẻ
     * @author BNDung
     * @param {*} state
     * @param {*} param
     */
    removeExerciseForShare (state, param) {
      state.exerciseForShare = state.exerciseForShare.filter((x) => x !== param)
      state.shareExercises.map((item) => {
        if (item.Id === param.Id) {
          item.choosed = false
        }
        return item
      })
    },
    // hàm bật tắt xem đáp án
    setShowAnswer (state, param) {
      state.isShowAnswer = param
    },
    // set thư viện
    setLibraryExercise (state, libraryExercises) {
      state.libraryExercises = libraryExercises
    },
    setLibraryExerciseMISA (state, libraryExercises) {
      state.libraryExercisesMISA = libraryExercises
    },
    // set object kho học liệu
    setFilterExercise (state, exerciseStore) {
      state.exerciseStore = exerciseStore
    },
    // set object thư viện
    setFilterLibrary (state, exerciseLibrary) {
      state.exerciseLibrary = exerciseLibrary
    },
    // set object chia sẻ
    setFilterShare (state, currentItem) {
      state.filterStorage = JSON.parse(JSON.stringify(currentItem))
      state.currentItem = currentItem
    },

    // Set lại giá trị khi gọi lại page
    setUpdateDataShare (state, dataShare) {
      state.shareExercises = dataShare.shareExercises
    },

    // set List chia sẻ
    setShareExercise (state, shareExercises) {
      if (state.currentPage > 1) {
        state.dataShares = state.dataShares.concat({ shareExercises, index: state.currentPage })
      } else {
        // Lấy giá trị lần đầu
        state.exerciseForShare.forEach(element => {
          const index = shareExercises.findIndex(shareExercise => shareExercise.Id === element.Id)
          if (index !== -1) {
            shareExercises[index] = element
          }
        })
        state.dataShares = [{ shareExercises, index: state.currentPage }]
      }
      state.dataShares.forEach(data => {
        if (data.index === state.currentPage) {
          state.shareExercises = data.shareExercises
        }
      })
      // state.shareExercises = state.dataShares[0].shareExercises
    },

    setExerciseStorePopup (state, exercisestores) {
      state.exercisestoresPopup = exercisestores
    },
    // Tổng số bản ghi chia sẻ
    setTotalExercisePopup (state, totalExercise) {
      state.totalExercisePopup = totalExercise
    },
    // set List thư viện
    setExerciseStore (state, exercisestores) {
      state.exerciseStoresOld = [...exercisestores]
      if (state.exerciseStoresOld.length === 0) {
        state.exercisestores = exercisestores
      } else {
        state.exercisestores = state.exercisestores.concat(state.exerciseStoresOld)
      }
    },

    // Reset lại dữ liệu trước khi gọi api
    resetExerciseStore (state) {
      state.exercisestores = []
      state.exerciseStoresOld = []
      state.totalExercise = 0
    },

    setExerciseStores (state, exerciseStores) {
      state.exercisestores = exerciseStores
    },

    // Tổng số bản ghi kho học liệu
    setTotalExercise (state, totalExercise) {
      state.totalExercise = totalExercise
    },
    // Tổng số bản ghi thư viện
    setTotalLibrary (state, totalLibrary) {
      state.totalLibrary = totalLibrary
    },
    // Tổng số bản ghi thư viện MISA
    settotalExerciseMISA (state, totalExerciseMISA) {
      state.totalExerciseMISA = totalExerciseMISA
    },

    setExercise (state, exercise) {
      if (typeof exercise !== 'undefined') {
        state.exerciseDefault = JSON.parse(JSON.stringify(exercise))
      }
      state.exercise = exercise
    },

    setCounter (state, countStatus) {
      state.counter = countStatus
    },

    setCounterLibrary (state, countLibrary) {
      state.countLibrary = countLibrary
    },

    setCounterMISAStore (state, countMISAStore) {
      state.countMISAStore = countMISAStore
    },
    deleteExerciseStore (state, exercisestores) {
      state.exercisestores = state.exercisestores.filter((item) => {
        return item !== exercisestores
      })
      state.counter.ExerciseCompleted--
      state.totalExercise--
    },

    updateviewActive (state, viewActive) {
      state.viewActive = viewActive
    },

    /**
     * set data môn học : học liệu chia sẻ
     */
    setListSubjectShareSchool (state, data) {
      state.subjectShareSchool = data
    },

    /**
     * set data giáo viên tích cực
     * @param {*} state
     * @param {*} data
     */
    setListTeacherPositive (state, data) {
      state.teacherPositive = data
    },

    setExerciseShareSchoolBySubject (state, data) {
      // state.exerciseShareSchool = data
      state.exerciseShareSchoolOld = [...data]
      if (state.exerciseShareSchoolOld.length === 0) {
        state.exerciseShareSchool = data
      } else {
        state.exerciseShareSchool = state.exerciseShareSchool.concat(state.exerciseShareSchoolOld)
      }
    },

    /**
     * @author NVDUC
     * set giá trị cho
     */
    setTeacherExerciseInformation (state, data) {
      state.totalExerciseInformation = data
    },

    /**
     * @author NVDUC
     * set giá trị cho
     */
    setTeacherRankingOld (state, data) {
      state.teacherRankingOld = data
    },

    setTeacherFavoriteExercise (state, data) {
      state.exerciseFavoriteOld = data.map(element => {
        element.isFavoriteExercise = true
        return element
      })

      if (state.exerciseFavoriteOld.length === 0) {
        state.favoriteExercise = data.map(element => {
          element.isFavoriteExercise = true
          return element
        })
      } else {
        state.favoriteExercise = state.favoriteExercise.concat(state.exerciseFavoriteOld)
      }
    },

    setExerciseShareSchoolParam (state, data) {
      state.shareSchoolParam = data
    },

    setListExerciseSharePublicOverview (state, data) {
      state.exercisePublicOverview = data
    },

    setListExerciseSharePublic (state, data) {
      state.exerciseSharePublicOld = [...data]
      if (state.exerciseSharePublicOld.length === 0) {
        state.exerciseSharePublic = data
      } else {
        state.exerciseSharePublic = state.exerciseSharePublic.concat(state.exerciseSharePublicOld)
      }
    },

    setListExerciseSharePublicConCat (state, data) {
      state.exerciseSharePublic = state.exerciseSharePublic.concat(data)
    },
    /**
     * set giá trị tổng số bản ghi tìm kiếm tab CĐGV
     */
    setTotalExerciseSharePublic (state, data) {
      state.totalExerciseSharePublic = data
    },

    setListTeacherGifCard (state, data) {
      state.listTeacherGifCard = data
    },
    /**
     * set giá trị cho bộ filter tìm kiếm trong tab cộng đồng giáo viên
     */
    setFilterCommunity (state, data) {
      state.filterCommunity = data
    },
    /**
     * set giá trị cho biển kiểm tra click tab Cộng đồng giáo viên
     */
    setResetFilter (state, data) {
      state.resetFilter = data
    },

    setTotalFavoriteExercise (state, data) {
      state.totalFavoriteExercise = data
    },

    settotalExerciseShareSchoolBySubject (state, data) {
      state.totalExerciseShareSchoolBySubject = data
    },

    /**
     * @description Set giá trị cho số lượng học liệu sưu tầm của giáo viên
     * @author lhlong
     */
    setUsedCount (state, param) {
      state.usedCount = param
    },

    setIsShowRecommendShareExercise (state) {
      state.isShowRecommendShareExercise = true
    },

    setIsNotShowRecommendShareExercise (state) {
      state.isShowRecommendShareExercise = false
    },

    setNumberShareExerciseToUp (state, data) {
      state.numberShareExerciseToUp = data
    }

  },

  actions: {
    /**
     *Lấy thông tin lớp học liệu theo trạng thái
     * @param {*} context
     * @param {*} status
     * @returns
     * CreateBy: NVDuc 27.05.2021
     */
    getCountStoreStatus (context) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync('/count')
          .then((res) => {
            context.commit('setCounter', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy tổng thông tin của thư viện học liệu
     * @param {*} context
     * @returns
     */
    getCountLibrary (context) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync('/count-library')
          .then((res) => {
            context.commit('setCounter', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    getCountMISAStore (context) {
      return new Promise((resolve, reject) => {
        MISAStoreAPI.getAsync('/count-store')
          .then((res) => {
            context.commit('setCounterMISAStore', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Tìm kiếm giá trị khối, môn, chủ đề , queryText
     * CreateBy: NVDuc 27.05.2021
     */
    getfilterTopic (context, exerciseStore) {
      if (exerciseStore.Type === Enumeration.ExerciseType.Compose) {
        // nếu là loại soạn mới
        const query =
          `gradeID=${exerciseStore.GradeID ? exerciseStore.GradeID : ''}` +
          `&subjectID=${
            exerciseStore.SubjectID ? exerciseStore.SubjectID : ''
          }` +
          `&topicID=${exerciseStore.TopicID ? exerciseStore.TopicID : ''}` +
          `&status=${exerciseStore.Status}` +
          `&queryText=${
            exerciseStore.queryText ? exerciseStore.queryText : ''
          }` +
          `&pageIndex=${
            exerciseStore.pageIndex ? exerciseStore.pageIndex : ''
          }` +
          `&pageSize=${exerciseStore.pageSize ? exerciseStore.pageSize : ''}` +
          `&Type=${exerciseStore.Type}`
        return new Promise((resolve, reject) => {
          ExerciseStoreAPI.getAsync('filterCompose/exercise?' + query)
            .then((res) => {
              // lưu danh sách
              let exerciseStores = res.Data.PageData

              exerciseStores = exerciseStores.map(exerciseStore => {
                exerciseStore = handleMappingAnswer(exerciseStore, Enumeration.HandlePairingAnswerType.Revert)
                return exerciseStore
              })

              context.commit('setExerciseStore', exerciseStores)
              //  lưu tổng số câu
              context.commit('setTotalExercise', res.Data?.Total)

              resolve(res.Data)
            })
            .catch((err) => {
              reject(err)
            })
        })
      } else if (exerciseStore.Type === Enumeration.ExerciseType.Other) {
        // không phải loại nào cả
        const query =
          `gradeID=${exerciseStore.GradeID ? exerciseStore.GradeID : ''}` +
          `&subjectID=${
            exerciseStore.SubjectID ? exerciseStore.SubjectID : ''
          }` +
          `&topicID=${exerciseStore.TopicID ? exerciseStore.TopicID : ''}` +
          `&queryText=${
            exerciseStore.queryText ? exerciseStore.queryText : ''
          }` +
          `&status=${exerciseStore.Status}` +
          `&pageIndex=${
            exerciseStore.pageIndex ? exerciseStore.pageIndex : ''
          }` +
          `&pageSize=${exerciseStore.pageSize ? exerciseStore.pageSize : ''}` + `&sortType=${exerciseStore.sortType}`
        return new Promise((resolve, reject) => {
          ExerciseStoreAPI.getAsync('filter/exerciseStorage?' + query)
            .then((res) => {
              // lưu danh sách
              context.commit('setExerciseStore', res.Data.PageData)
              //  lưu tổng số câu
              context.commit('setTotalExercise', res.Data?.Total)

              resolve(res.Data)
            })
            .catch((err) => {
              reject(err)
            })
        })
      } else {
        const query =
          `gradeID=${exerciseStore.GradeID ? exerciseStore.GradeID : ''}` +
          `&subjectID=${
            exerciseStore.SubjectID ? exerciseStore.SubjectID : ''
          }` +
          `&topicID=${exerciseStore.TopicID ? exerciseStore.TopicID : ''}` +
          `&queryText=${
            exerciseStore.queryText ? exerciseStore.queryText : ''
          }` +
          `&shareType=${
            exerciseStore.shareType ? exerciseStore.shareType : ''
          }` +

          `&pageIndex=${
            exerciseStore.pageIndex ? exerciseStore.pageIndex : ''
          }` +
          `&pageSize=${exerciseStore.pageSize ? exerciseStore.pageSize : ''}`

        return new Promise((resolve, reject) => {
          ExerciseStoreAPI.getAsync('filter/exercise?' + query)
            .then((res) => {
              context.commit('setExerciseStore', res.Data?.PageData)
              // context.commit('setFilterExercise', exerciseStoreFR)
              context.commit('setFilterLibrary', exerciseStore)
              // context.commit('setFilterShare', exerciseStore)

              context.commit('setTotalExercise', res.Data?.Total)
              resolve(res.Data?.PageData)
            })
            .catch((err) => {
              reject(err)
            })
        })
      }
    },

    /**
     * Tìm kiếm học liệu tham khảo khi soạn bài giá trị khối, môn, chủ đề , queryText
     * CreateBy: VHSON 05.01.2022
     */
    getExerciseExcludeQuestions (context, exerciseStore) {
      const query =

      `gradeID=${exerciseStore.GradeID ? exerciseStore.GradeID : ''}` +
    `&subjectID=${
      exerciseStore.SubjectID ? exerciseStore.SubjectID : ''
    }` +
    `&topicID=${exerciseStore.TopicID ? exerciseStore.TopicID : ''}` +
    `&queryText=${
      exerciseStore.queryText ? exerciseStore.queryText : ''
    }` +
    `&shareType=${
      exerciseStore.shareType ? exerciseStore.shareType : ''
    }` +

    `&pageIndex=${
      exerciseStore.pageIndex ? exerciseStore.pageIndex : ''
    }` +
    `&pageSize=${exerciseStore.pageSize ? exerciseStore.pageSize : ''}` +
    `&status=${exerciseStore.Status}` +
    `&type=${exerciseStore.Type}`

      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync('filter/exclude-questions?' + query)
          .then((res) => {
            context.commit('setExerciseStores', res.Data?.PageData)
            // context.commit('setFilterExercise', exerciseStoreFR)
            context.commit('setFilterLibrary', res.Data?.PageData)
            // context.commit('setFilterShare', exerciseStore)

            context.commit('setTotalExercise', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Lấy all dữ liệu màn thư viện học liệu trong trường
     * @param {*} context
     * @param {*} exerciseLibrary
     * @returns
     */
    getfillerLibraryExercise (context, exerciseLibrary) {
      const query =
        `gradeID=${exerciseLibrary.GradeID ? exerciseLibrary.GradeID : ''}` +
        `&subjectID=${
          exerciseLibrary.SubjectID ? exerciseLibrary.SubjectID : ''
        }` +
        `&topicID=${exerciseLibrary.TopicID ? exerciseLibrary.TopicID : ''}` +
        `&queryText=${
          exerciseLibrary.queryText ? exerciseLibrary.queryText : ''
        }` +
        `&shareType=${
          exerciseLibrary.shareType ? exerciseLibrary.shareType : ''
        }` +
        `&pageIndex=${
          exerciseLibrary.pageIndex ? exerciseLibrary.pageIndex : ''
        }` +
        `&pageSize=${exerciseLibrary.pageSize ? exerciseLibrary.pageSize : ''}`
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync('filter/library?' + query)
          .then((res) => {
            context.commit('setExerciseStore', res.Data?.PageData)
            context.commit('setTotalExercise', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * lấy All dữ liệu màn thư viện học liệu quả MISA
     * @param {} context
     * @param {*} exerciseLibrary
     * @returns
     */
    getFilterExerciseStore (context, exerciseLibrary) {
      const query =
        `gradeID=${exerciseLibrary.GradeID ? exerciseLibrary.GradeID : ''}` +
        `&subjectID=${
          exerciseLibrary.SubjectID ? exerciseLibrary.SubjectID : ''
        }` +
        `&topicID=${exerciseLibrary.TopicID ? exerciseLibrary.TopicID : ''}` +
        `&queryText=${
          exerciseLibrary.queryText ? exerciseLibrary.queryText : ''
        }` +
        `&pageIndex=${
          exerciseLibrary.pageIndex ? exerciseLibrary.pageIndex : ''
        }` +
        `&pageSize=${exerciseLibrary.pageSize ? exerciseLibrary.pageSize : ''}`
      return new Promise((resolve, reject) => {
        MISAStoreAPI.getAsync('excercise-librarys?' + query)
          .then((res) => {
            context.commit('setExerciseStore', res.Data?.PageData)
            context.commit('setTotalExercise', res.Data?.Total)
            resolve(res.Data?.PageData)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    getExercise (context, params) {
      context.commit('setExercise', params)
    },

    /**
     * Xóa 1 bản ghi học liệu
     * @param {*} context
     * @param {*} params
     * @returns
     * CreateBy: NVDuc 27.05.2021
     */
    deleteExerciseStore (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.deleteAsync(params.Id)
          .then((res) => {
            context.commit('deleteExerciseStore', params)
            const listGiftCards = sessionStorage.get(sessionStorageKeys.TEACHER_GIFT_CARD)
            // Giảm số lượt sử dụng trên session
            const index = listGiftCards.findIndex(element => element.GiftCardType === Enumeration.GiftCardType.ComposeExerciseStore)
            listGiftCards[index].UsedCount--
            sessionStorage.set(sessionStorageKeys.TEACHER_GIFT_CARD, listGiftCards)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy học liệu từ thư viện về kho
     * @param {*} context
     * @param {*} params
     * @returns
     */
    insertExerciseLibrary (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.postAsync('/insert?id=' + params.Id + '&Source=' + params.SourceLibrary)
          .then((res) => {
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy học liệu từ học liệu tham khảo về kho
     * @param {*} context
     * @param {*} params
     * @returns
     */
    insertExerciseStore (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.postAsync('/insert?id=' + params.Id + '&Source=' + params.SourceMISA)
          .then((res) => {
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     *Lấy thông tin lớp học liệu theo trạng thái
     * @param {*} context
     * @param {*} status
     * @returns
     */
    getExerciseStoreStatus (context, status) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync(`/status/${status}`)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy về danh sách kho học liệu theo giáo viên
     * @param {*} context
     * @param {*} type: 1-soạn mới, 2-tải về
     * @param {*} gradeId: id khối
     * @param {*} subjectId: id môn
     * @param {*} topicId: id toping
     * @param {*} searchTemp: chuỗi tìm kiếm
     * @returns
     * nnkhanh
     */
    getExerciseOwner (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync(
          `/owner?type=${params.Type ? params.Type : ''}&status=${
            params.Status ?? ''
          }&gradeId=${params.GradeID ? params.GradeID : ''}&subjectId=${
            params.SubjectID ? params.SubjectID : ''
          }&topicId=${params.TopicID ? params.TopicID : ''}&searchTemp=${
            params.SearchTemp ? params.SearchTemp : ''
          }`
        )
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     *Lấy thông tin lớp học liệu theo id
     * @param {*} context
     * @param {*} id
     * @returns
     */
    getExerciseStoreById (context, value) {
      // nếu là xem chi tiết học liệu đã chọn
      if (
        parseInt(value.actionType) !==
        Enumeration.PreviewAction.CompleteClassroom
      ) {
        return new Promise((resolve, reject) => {
          ExerciseStoreAPI.getAsync(`exercise?id=${value.id}&source=${value.source}`)
            .then((res) => {
              const exerciseStore = res.Data
              const exerciseStoreHandle = handleMappingAnswer(exerciseStore, Enumeration.HandlePairingAnswerType.Revert)
              context.commit('setExercise', exerciseStoreHandle)
              resolve(true)
            })
            .catch((err) => {
              reject(err)
            })
        })
      } else {
        // nếu là xem chi tiết của bài tập đã giao
        return new Promise((resolve, reject) => {
          ExerciseCardAPI.getAsync(`exercise-store/${value.id}`)
            .then((res) => {
              context.commit('setExercise', res.Data)
              resolve(true)
            })
            .catch((err) => {
              reject(err)
            })
        })
      }
    },
    getByIdExerciseStore (context, exerciseStore) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync(`/${exerciseStore}`)
          .then((res) => {
            const exercise = handleMappingAnswer(res.Data, Enumeration.HandlePairingAnswerType.Revert)
            context.commit('setExercise', exercise)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    getExerciseCard (context, exer) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(`/exercise-store/${exer}`)
          .then((res) => {
            context.commit('setExercise', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    updateviewActive (context, viewActive) {
      context.commit('updateviewActive', viewActive)
    },

    getSubmitExrcise (context, value) {
      return new Promise((resolve, reject) => {
        ExerciseCardAPI.getAsync(`/grade-submit-exercise/${value.id}`)
          .then((res) => {
            context.commit('setExercise', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy các bản ghi bài tập theo paging của giáo viên đó
     * @author BNDung
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getAllExerciseShared (context, currentItem) {
      return new Promise((resolve, reject) => {
        const query =
          `gradeID=${currentItem.GradeID ? currentItem.GradeID : ''}` +
          `&subjectID=${currentItem.SubjectID ? currentItem.SubjectID : ''}` +
          `&topicID=${currentItem.TopicID ? currentItem.TopicID : ''}` +
          `&queryText=${currentItem.queryText ? currentItem.queryText : ''}` +
          `&pageIndex=${currentItem.pageIndex ? currentItem.pageIndex : ''}` +
          `&pageSize=${currentItem.pageSize ? currentItem.pageSize : ''}`
        ExerciseStoreAPI.getAsync('exercise-store-by-teacher?' + query)
          .then((res) => {
            context.commit('setFilterShare', currentItem)
            context.commit('setShareExercise', res.Data?.PageData)
            context.commit('setTotalExercisePopup', res.Data?.Total)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Hàm cập nhật lại các bài tập được chia sẻ
     * @author BNDung
     * @param {*} context
     * @param {*} params
     * @returns
     */
    updateIsShared (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.postAsync('update-is-shared', params)
          .then((res) => {
            context.commit('setExerciseShared', params.ListId)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Hàm chia sẻ nhiều học liệu lên cộng đồng
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async updateIsSharedPublic (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.postAsync('update-is-public-shared', params)
          .then((res) => {
            context.commit('setExerciseShared', params.ListId)
            if (res.Data) {
              context.dispatch('getRankingGiftCard', res.Data, { root: true })
            }
            const ranking = sessionStorage.get(sessionStorageKeys.TEACHER_RANKING)
            // Giảm số lượt sử dụng trên session
            ranking.SharedAmount = ranking.SharedAmount + params.ListId.length
            ranking.AmountToUpShare = ranking.AmountToUpShare - params.ListId.length
            sessionStorage.set(sessionStorageKeys.TEACHER_RANKING, ranking)
            ranking.AmountToUpShare <= 2 && ranking.Ranking !== Enumeration.TeacherRanking.FourDotZero && ranking.AmountToUpShare > 0
              // Nếu còn nhỏ hơn 2 học liệu nữa thì hiện
              ? context.commit('setIsShowRecommendShareExercise')
              : context.commit('setIsNotShowRecommendShareExercise')
            context.commit('setNumberShareExerciseToUp', ranking.AmountToUpShare)

            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    // Cập nhật lại trạng thái khi thay đổi bên kho học liệu IsShare=false
    updateIsSharedExercise (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.postAsync('update-is-shared', params)
          .then((res) => {
            context.commit('setExerciseSharedExercise', params.ListId)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    // Cập nhật khi set lại xóa bỏ dọc liệu trong thư viện
    updateIsSharedLibrary (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.postAsync('update-is-shared', params)
          .then((res) => {
            context.commit('setExerciseSharedLibrary', params.ListId)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Thêm bài tập mẫu cho giáo viên lần đầu đi từ Emis Core sang
     * @param {*} context
     * @param {*} params
     * @returns
     */
    insertExerciseStoreDefault (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.postAsync('/insert-data-default', params)
          .then((res) => {
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVDUC
     * @param {*} context
     * @param {*} params
     * @returns Láy danh sách môn của liệu trong trường
     */
    getListSubjectShareSchool (context) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync('/subject-share-school')
          .then((res) => {
            context.commit('setListSubjectShareSchool', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVDUC
     * @returns Lấy danh sách giáo viên tích cực trong 10 ngày
     */
    getListTeacherPositive (context, data) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync(`/positive-teacher/${data}`)
          .then((res) => {
            context.commit('setListTeacherPositive', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách theo môn học của học liệu chia sẻ trong trường
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getListExerciseShareSchoolBySubject (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync('/get-school-by-subject', { params: params })
          .then((res) => {
            context.commit('setExerciseShareSchoolBySubject', res.Data?.PageData)
            context.commit('settotalExerciseShareSchoolBySubject', res.Data?.Total)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVDUC
     * @param {*} context
     * @param {*} params
     * @returns lấy tổng số học liệu hiển thị Ranking
     */
    getTeacherExerciseInformationForRanking (context) {
      return new Promise((resolve, reject) => {
        TeacherRankingAPI.getAsync('/get-teacher-ranking')
          .then((res) => {
            context.commit('setTeacherExerciseInformation', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVDUC
     * @param {*} context
     * @param {*} params
     * @returns Lấy tất cả học liệu giáo viên đã yêu thích
     */
    getTeacherFavoriteExercise (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseFavoriteAPI.getAsync('/favorite-exercise', { params: params })
          .then((res) => {
            context.commit('setTeacherFavoriteExercise', res.Data?.PageData)
            context.commit('setTotalFavoriteExercise', res.Data?.Total)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVDUC
     * @param {*} context
     * Chia sẻ học liệu trong trường
     */
    shareExerciseToSchool (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync('/share-school', { params: params })
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVDUC
     * @param {*} context
     * @param {*} params
     * @returns Chia sẻ học liệu cho cộng đồng
     */
    shareExerciseToPublic (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync('/share-public', { params: params })
          .then((res) => {
            const ranking = sessionStorage.get(sessionStorageKeys.TEACHER_RANKING)
            // Giảm số lượt sử dụng trên session
            ranking.SharedAmount--
            ranking.AmountToUpShare++
            sessionStorage.set(sessionStorageKeys.TEACHER_RANKING, ranking)
            ranking.AmountToUpShare <= 2 && ranking.Ranking !== Enumeration.TeacherRanking.FourDotZero && ranking.AmountToUpShare > 0
              // Nếu còn nhỏ hơn 2 học liệu nữa thì hiện
              ? context.commit('setIsShowRecommendShareExercise')
              : context.commit('setIsNotShowRecommendShareExercise')
            context.commit('setNumberShareExerciseToUp', ranking.AmountToUpShare)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVDUC
     * Thêm vào yêu thích
     * @param {*} context
     * @param {*} params
     * @returns
     */
    insertFavoriteExercise (context, params) {
      const query =
      `exerciseId=${params.exerciseId}&source=${params.source}`
      return new Promise((resolve, reject) => {
        ExerciseFavoriteAPI.postAsync('favorite-param?' + query)
          .then((res) => {
            const listGiftCards = sessionStorage.get(sessionStorageKeys.TEACHER_GIFT_CARD)
            // Giảm số lượt sử dụng trên session
            const index = listGiftCards.findIndex(element => element.GiftCardType === Enumeration.GiftCardType.FavoriteExerciseStore)
            listGiftCards[index].UsedCount++
            sessionStorage.set(sessionStorageKeys.TEACHER_GIFT_CARD, listGiftCards)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     *Sưu tầm học liệu
     * @param {} context
     * @param {*} params
     * @returns
     */
    insertUseGiftCardCollectExercise (context, params) {
      const query =
      `exerciseId=${params}&giftCardType=${Enumeration.GiftCardType.UsedExerciseStore}`
      return new Promise((resolve, reject) => {
        TeacherGiftCardAPI.postAsync('use-gift-card-collect?' + query)
          .then((res) => {
            const listGiftCards = sessionStorage.get(sessionStorageKeys.TEACHER_GIFT_CARD)
            // Giảm số lượt sử dụng trên session
            const index = listGiftCards.findIndex(element => element.GiftCardType === Enumeration.GiftCardType.UsedExerciseStore)
            listGiftCards[index].UsedCount++
            context.commit('setUsedCount', listGiftCards[index].UsedCount)

            sessionStorage.set(sessionStorageKeys.TEACHER_GIFT_CARD, listGiftCards)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVDUC
     * Lấy danh sách Học liệu cộng đồng giáo viên màn hỉnh tổng quan
     * @param {*} context
     * @returns
     */
    getListExerciseSharePublicOverview (context) {
      return new Promise((resolve, reject) => {
        MISAStoreAPI.getAsync('/get-public-overview')
          .then((res) => {
            context.commit('setListExerciseSharePublicOverview', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVDUC
     * Lấy danh sách tổng quan học liệu miễn phí/ học liệu dành cho bạn
     * @param {*} context
     * @returns
     */
    getListExerciseSharePublic (context, params) {
      return new Promise((resolve, reject) => {
        MISAStoreAPI.getAsync('/get-public-filter', { params: params })
          .then((res) => {
            context.commit('setListExerciseSharePublic', res.Data?.PageData)
            context.commit('setTotalExerciseSharePublic', res.Data?.Total)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * @author TTLONG
     * lấy danh sách học liệu được tìm kiếm trong tab cộng đồng giáo viên
     * @param {*} context
     * @returns
     */
    getListExerciseSharePublicBySort (context, params) {
      return new Promise((resolve, reject) => {
        MISAStoreAPI.getAsync('/public-filter-sort-option', { params: params })
          .then((res) => {
            context.commit('setListExerciseSharePublic', res.Data?.PageData)
            context.commit('setTotalExerciseSharePublic', res.Data?.Total)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * @author TTLONG
     * lấy danh sách học liệu được tìm kiếm trong tab chia sẻ trong trường
     * @param {*} context
     * @returns
     */
    getListExerciseShareSchoolBySort (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync('/school-filter-sort-option', { params: params })
          .then((res) => {
            context.commit('setListExerciseSharePublic', res.Data?.PageData)
            context.commit('setTotalExerciseSharePublic', res.Data?.Total)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Lấy danh sách sưu tầm học liệu
     * @param {*} context
     * @returns
     */
    getListTeacherGifCard (context) {
      return new Promise((resolve, reject) => {
        TeacherGiftCardAPI.getAsync('/get-teacher-giftcard')
          .then((res) => {
            context.commit('setListTeacherGifCard', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVDUC
     * Kiểm tra xem đã yêu thích hay chưa
     * @param {*} context
     * @returns
     */
    checkIsFavoriteCourse (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseFavoriteAPI.getAsync('/check-is-favorite', { params: params })
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVDUC
     * Xóa dữ liệu bảng FavoriteExerciseStore
     * @param {*} context
     * @param {*} params
     * @returns
     */
    deleteCourse (context, params) {
      const query =
      `exerciseId=${params}`
      return new Promise((resolve, reject) => {
        ExerciseFavoriteAPI.postAsync('delete-course-param?' + query)
          .then((res) => {
            const listGiftCards = sessionStorage.get(sessionStorageKeys.TEACHER_GIFT_CARD)
            // Giảm số lượt sử dụng trên session
            const index = listGiftCards.findIndex(element => element.GiftCardType === Enumeration.GiftCardType.FavoriteExerciseStore)
            listGiftCards[index].UsedCount--
            sessionStorage.set(sessionStorageKeys.TEACHER_GIFT_CARD, listGiftCards)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getExerciseStoreByID (context, params) {
      return new Promise((resolve, reject) => {
        MISAStoreAPI.getAsync(`detail?id=${params}`)
          .then((res) => {
            const exercise = handleMappingAnswer(res.Data, Enumeration.HandlePairingAnswerType.Revert)
            context.commit('setExercise', exercise)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * lấy dữ liệu học liệu theo ID
     * @param {*} context
     * @param {*} params
     */
    getExerciseDetailByID (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync('/exercise-detail-public', { params: params })
          .then((res) => {
            const exercise = handleMappingAnswer(res.Data, Enumeration.HandlePairingAnswerType.Revert)
            context.commit('setExercise', exercise)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
